import _classCallCheck from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { createElement as h, Component } from 'react';
import FileInputPlugin from '@uppy/file-input';
/**
 * React component that renders an area in which files can be dropped to be
 * uploaded.
 */

var FileInput =
/*#__PURE__*/
function (_Component) {
  _inherits(FileInput, _Component);

  function FileInput() {
    _classCallCheck(this, FileInput);

    return _possibleConstructorReturn(this, _getPrototypeOf(FileInput).apply(this, arguments));
  }

  _createClass(FileInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.installPlugin();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // eslint-disable-next-line react/destructuring-assignment
      if (prevProps.uppy !== this.props.uppy) {
        this.uninstallPlugin(prevProps);
        this.installPlugin();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.uninstallPlugin();
    }
  }, {
    key: "installPlugin",
    value: function installPlugin() {
      var _this$props = this.props,
          uppy = _this$props.uppy,
          locale = _this$props.locale,
          pretty = _this$props.pretty,
          inputName = _this$props.inputName,
          id = _this$props.id;
      var options = {
        id: id || 'FileInput',
        locale: locale,
        pretty: pretty,
        inputName: inputName,
        target: this.container
      };
      uppy.use(FileInputPlugin, options);
      this.plugin = uppy.getPlugin(options.id);
    }
  }, {
    key: "uninstallPlugin",
    value: function uninstallPlugin(props) {
      if (props === void 0) {
        props = this.props;
      }

      var _props = props,
          uppy = _props.uppy;
      uppy.removePlugin(this.plugin);
    } // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types

  }, {
    key: "render",
    value: function render() {
      var _this = this;

      return h('div', {
        className: 'uppy-Container',
        ref: function ref(container) {
          _this.container = container;
        }
      });
    }
  }]);

  return FileInput;
}(Component); // Must be kept in sync with @uppy/file-input/src/FileInput.jsx


FileInput.defaultProps = {
  locale: undefined,
  pretty: true,
  inputName: 'files[]'
};
export default FileInput;